import { REQUEST_FORM_SECTION_DEFINITIONS } from "@RequestFormV2/sectionDefinitions";

const SECTION_KEY_TO_ANALYTICS_NAME = Object.fromEntries(
  REQUEST_FORM_SECTION_DEFINITIONS.map(({ key, defaultMessage }) => [key, defaultMessage]),
);

const SPECIAL_SECTION_NAMES: Record<string, string> = {
  confirmation: "Confirmation",
  header: "Header",
  unknown: "Unknown",
};

/** Maps internal accordion section keys to human-readable names for PostHog. */
export function toAnalyticsSectionName(sectionKey: string): string {
  return SECTION_KEY_TO_ANALYTICS_NAME[sectionKey] ?? SPECIAL_SECTION_NAMES[sectionKey] ?? sectionKey;
}
